import { render } from "./EditarInforme.vue?vue&type=template&id=18ff2c9f"
import script from "./EditarInforme.vue?vue&type=script&lang=js"
export * from "./EditarInforme.vue?vue&type=script&lang=js"

import "./EditarInforme.vue?vue&type=style&index=0&id=18ff2c9f&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__